export default __webpack_public_path__ + "static/media/honey.fd93bf93.svg";